var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-spin", { attrs: { spinning: _vm.loading, tip: "加载中..." } }, [
    _c(
      "div",
      { staticStyle: { "min-height": "500px" } },
      [
        _vm.listData.length > 0
          ? _c("a-list", {
              attrs: {
                "item-layout": "vertical",
                size: "large",
                pagination: _vm.pagination,
                "data-source": _vm.listData
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "renderItem",
                    fn: function(item, index) {
                      return _c(
                        "a-list-item",
                        { key: "item.title", staticClass: "ch2-list-item" },
                        [
                          _c("template", { slot: "actions" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("datetime")(
                                    item.publishTime,
                                    "YYYY-MM-DD HH:mm"
                                  )
                                ) + " "
                              )
                            ]),
                            _c(
                              "span",
                              [
                                _c("a-avatar", {
                                  staticStyle: {
                                    width: "20px",
                                    height: "20px",
                                    "margin-right": "3px"
                                  },
                                  attrs: { size: "small" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "icon",
                                        fn: function() {
                                          return [
                                            _c("img", {
                                              attrs: {
                                                src: item.authorAvatar,
                                                alt: ""
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(_vm._s(item.author))
                              ],
                              1
                            ),
                            _c(
                              "a",
                              { attrs: { href: item.url, target: "_blank" } },
                              [_vm._v(_vm._s(item.webName))]
                            ),
                            _c("span", [
                              _vm._v("发布于 " + _vm._s(item.ipRegion) + " ")
                            ]),
                            item.postPlace
                              ? _c("span", [
                                  _vm._v(" " + _vm._s(item.postPlace) + " ")
                                ])
                              : _vm._e()
                          ]),
                          _c("a-list-item-meta", [
                            _c(
                              "div",
                              {
                                staticClass: "title",
                                attrs: { slot: "title" },
                                slot: "title"
                              },
                              [
                                _c("div", { staticStyle: { width: "90%" } }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "bold",
                                        "margin-right": "10px"
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(index + 1) + " ")]
                                  ),
                                  _c(
                                    "span",
                                    [
                                      item.warningLevel === 3
                                        ? _c(
                                            "a-tag",
                                            { attrs: { color: "#ff0000" } },
                                            [_vm._v("重大")]
                                          )
                                        : _vm._e(),
                                      item.warningLevel === 2
                                        ? _c(
                                            "a-tag",
                                            { attrs: { color: "#f48b24" } },
                                            [_vm._v("严重")]
                                          )
                                        : _vm._e(),
                                      item.warningLevel === 1
                                        ? _c(
                                            "a-tag",
                                            { attrs: { color: "#e4c400" } },
                                            [_vm._v("一般")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  item.isCommentData > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            border: "1px solid #5090f1",
                                            color: "#5090f1",
                                            "font-size": "12px",
                                            "margin-right": "6px"
                                          }
                                        },
                                        [_vm._v(" 评论 ")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "title-i",
                                      on: {
                                        click: function($event) {
                                          return _vm.toDetail(item)
                                        }
                                      }
                                    },
                                    [
                                      _c("TextHighlighter", {
                                        attrs: {
                                          text: item.title,
                                          keywords: item.redKeyWord
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          ]),
                          _c(
                            "div",
                            [
                              item.isCommentData === 0
                                ? _c("TextHighlighter", {
                                    attrs: {
                                      text: item.summary,
                                      keywords: item.redKeyWord
                                    }
                                  })
                                : _c("div", { staticClass: "list-comment" }, [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: { color: "#4e4e4e" },
                                        attrs: {
                                          href: item.originInfo.originUrl,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "user" }
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.originInfo.originAuthor
                                                ) +
                                                " "
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.originInfo.originContent
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                            ],
                            1
                          )
                        ],
                        2
                      )
                    }
                  }
                ],
                null,
                false,
                867770548
              )
            })
          : _c("a-empty")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }